import { connect } from 'react-redux'
import { fetchAssociateTypes, fetchAssociateTypesSuccess, fetchAssociateTypesFailure } from '../actions/associateTypes';
import AssociateTypesList from '../components/AssociateTypes';

const mapStateToProps = (state) => {
    return {
        associateTypeList: state.associateTypes.associateTypeList
    };
}

const mapDispatchToProps = (dispatch) => {
    return {
        fetchAssociateTypes: () => {
            dispatch(fetchAssociateTypes()).then((response) => {
                !response.error ? dispatch(fetchAssociateTypesSuccess(response.payload.data)) : dispatch(fetchAssociateTypesFailure(response.payload.data));
            });
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AssociateTypesList);



/** WEBPACK FOOTER **
 ** ./src/containers/AssociateTypeContainer.js
 **/